import { AfterViewInit, Component } from '@angular/core';
import { FspClassUseGridDataService } from './fsp-class-use-grid-data.service';
import {
  getFspClassUseGridToolbarItems,
  fspClassUseGridColumns,
} from './fsp-class-use-grid-model';
import { SelectableSettings } from '@progress/kendo-angular-grid';
import { combineLatest, filter, map, Observable, takeWhile, tap } from 'rxjs';
import { FreeServicesParcelRequestGridDto } from '../fsp-parcel-request-grid/free-services-parcel-request-grid-data-model';
import { FreeServicesParcelRequestGridDataService } from '../fsp-parcel-request-grid/free-services-parcel-request-grid-data.service';
import { KlasouzytekResponseDto } from '../../../gk-map/models';
import { GkKendoGridComponent } from '../../../gk-kendo';
import { FreeServicesRequestListGridDataService } from '../../free-services-request-list-grid/free-services-request-list-grid-data.service';
import { FreeServicesRequestListGridDto } from '../../free-services-request-list-grid/free-services-request-list-grid-data-model';

@Component({
  selector: 'app-fsp-class-use-grid',
  templateUrl: '../../../gk-kendo/gk-kendo-grid/gk-kendo-grid.component.html',
  standalone: false,
})
export class FspClassUseGridComponent
  extends GkKendoGridComponent<KlasouzytekResponseDto>
  implements AfterViewInit
{
  constructor(
    public fspClassUseGridDataService: FspClassUseGridDataService,
    public freeServicesParcelRequestGridDataService: FreeServicesParcelRequestGridDataService,
    public freeServicesRequestListGridDataService: FreeServicesRequestListGridDataService,
  ) {
    super(fspClassUseGridDataService);
  }

  override topGridToolbarItems = getFspClassUseGridToolbarItems();
  override columns = fspClassUseGridColumns;
  override selectable: SelectableSettings = { enabled: true, mode: 'single' };
  override sortable = true;

  selectedParcelGridItem: FreeServicesParcelRequestGridDto;
  selectedRequestListGridItem: FreeServicesRequestListGridDto;

  override ngAfterViewInit(): void {
    this.subscribeToCombinedSelections();
  }

  private subscribeToCombinedSelections(): void {
    const parcel$ = this.subscribeToParcelListGridSelectedKeys();
    const request$ = this.subscribeToRequestListGridSelectedKeys();

    combineLatest([parcel$, request$])
      .pipe(takeWhile(() => this.isAlive))
      .subscribe(([parcelItem, requestItem]) => {
        this.selectedParcelGridItem = parcelItem;
        this.selectedRequestListGridItem = requestItem;
        this.fetchGridData();
      });
  }

  subscribeToParcelListGridSelectedKeys(): Observable<FreeServicesParcelRequestGridDto> {
    return this.freeServicesParcelRequestGridDataService.$selection.pipe(
      takeWhile(() => this.isAlive),
      tap(() => {
        this.selectedParcelGridItem = undefined;
      }),
      filter(Boolean),
      map(
        (selection) =>
          selection.selectedRows[0]
            .dataItem as FreeServicesParcelRequestGridDto,
      ),
    );
  }

  subscribeToRequestListGridSelectedKeys(): Observable<FreeServicesRequestListGridDto> {
    return this.freeServicesRequestListGridDataService.$selection.pipe(
      takeWhile(() => this.isAlive),
      tap(() => {
        this.selectedRequestListGridItem = undefined;
      }),
      filter(Boolean),
      map(
        (selection) =>
          selection.selectedRows[0].dataItem as FreeServicesRequestListGridDto,
      ),
    );
  }

  fetchGridData(): void {
    this.fspClassUseGridDataService.$loading.next(true);

    this.freeServicesParcelRequestGridDataService
      .fetchParcelDetailsFromApi(
        this.selectedRequestListGridItem.ZamowUuid,
        this.selectedParcelGridItem.KdzialkaUuid,
      )
      .subscribe((data) => {
        this.fspClassUseGridDataService.$loading.next(false);
        this.fspClassUseGridDataService.next({
          data: data.Klasouzytki,
          total: data.Klasouzytki.length,
        });
      });
  }
}
